/* bs-faqs — Preguntas frecuentes (secciones separadas: hero+buscador / cuerpo).
   Opera a nivel documento para que el buscador (hero) filtre el accordion (cuerpo).
   - Accordion: abre/cierra cada pregunta.
   - Buscador: filtra preguntas/respuestas; oculta categorías vacías; estado "sin resultados".
   - Nav lateral: resaltado de la categoría visible (IntersectionObserver). */
(function () {
  'use strict';

  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }

  function init() {
    if (window.__bsFaqsInit) return;
    if (!document.querySelector('.bs-faqs-cat')) return;
    window.__bsFaqsInit = true;

    // Accordion (delegado en documento)
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-bs-faq-toggle]');
      if (!toggle) return;
      var item = toggle.closest('[data-bs-faq-item]');
      if (!item) return;
      var open = item.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    var search = document.querySelector('[data-bs-faq-search]');
    var empty = document.querySelector('[data-bs-faq-empty]');
    var cats = Array.prototype.slice.call(document.querySelectorAll('.bs-faqs-cat'));

    if (search) {
      search.addEventListener('input', function () {
        var q = norm(search.value.trim());
        var any = false;
        cats.forEach(function (cat) {
          var catHas = false;
          cat.querySelectorAll('[data-bs-faq-item]').forEach(function (item) {
            var match = q === '' || norm(item.textContent).indexOf(q) !== -1;
            item.style.display = match ? '' : 'none';
            if (match) catHas = true;
            if (q !== '' && match) item.classList.add('is-open');
            else if (q === '') item.classList.remove('is-open');
          });
          cat.style.display = catHas ? '' : 'none';
          if (catHas) any = true;
        });
        if (empty) empty.classList.toggle('is-visible', !any);
      });
    }

    var links = document.querySelectorAll('[data-bs-faq-navlink]');
    if (links.length && 'IntersectionObserver' in window) {
      var byId = {};
      links.forEach(function (l) { byId[l.getAttribute('data-bs-faq-navlink')] = l; });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var id = en.target.id.replace('faq-', '');
          links.forEach(function (l) { l.classList.remove('is-active'); });
          if (byId[id]) byId[id].classList.add('is-active');
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      cats.forEach(function (c) { obs.observe(c); });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { window.__bsFaqsInit = false; init(); });
})();
